import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IIncomeState } from './income.state';

export class IncomeSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly incomeState = (state: IRootState): IIncomeState => {
    return state.income as IIncomeState;
  };

  static readonly model = createSelector(IncomeSelectors.incomeState, (income: IIncomeState) => {
    return income.model;
  });

  static readonly data = createSelector(IncomeSelectors.incomeState, (income: IIncomeState) => {
    return income.data;
  });
}
